import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import NotFoundPage from "./pages/NotFoundPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import UserDashboard from "./pages/UserDashboard.jsx";
import LandingPage from "./pages/landingpage/LandingPage.jsx";
import { AuthProvider } from "./context/AuthProvider";
import Resetpwd from "./pages/Resetpwd";
import Forgotpwd from "./pages/Forgotpwd";
import About from "./pages/About";
import Contact from "./pages/Contact.jsx";
import Update from "./pages/Update.jsx";
import Milestone from "./pages/Milestone.jsx";
import UDLandingUi from "./pages/fragments/UsersDashComp/UDLandingUi.jsx";
import UDMktOverviewUi from "./pages/fragments/UsersDashComp/UDMktOverviewUi.jsx";
import UDSettingsUi from "./pages/fragments/UsersDashComp/UDSettingsUi.jsx";
import UDTxnhistoryUI from "./pages/fragments/UsersDashComp/UDTxnhistoryUI.jsx";
import UDWalletUi from "./pages/fragments/UsersDashComp/UDPerformUi.jsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProvider } from "@toolpad/core/AppProvider";
import LandROut from "./pages/LandROut.jsx";
import UDDeposit from "./pages/fragments/UsersDashComp/UDDeposit.jsx";
import AdminDashboard from "./pages/fragments/AdminDashboardComp/AdminDashboard.jsx";
import ADLandingUi from "./pages/fragments/AdminDashboardComp/adminUi/ADLandingUi.jsx";
import ADSingleUserUi from "./pages/fragments/AdminDashboardComp/adminUi/ADSingleUserUI.jsx";
import ADUsersUi from "./pages/fragments/AdminDashboardComp/adminUi/ADUsersUi.jsx";
import ADUsersWithDepositUi from "./pages/fragments/AdminDashboardComp/adminUi/ADUsersWithDepositUi.jsx";
import ADUsersWithWithdrawaltUi from "./pages/fragments/AdminDashboardComp/adminUi/ADUserWithWithdrawalReq.jsx";
import RequiredAuth from "./pages/RequiredAuths.jsx";
import ServicePage from "./pages/Service.jsx";
import SupportPage from "./pages/Support.jsx";
import NewsPage from "./pages/News.jsx";
import ResetPasswordPage from "./pages/Resetpwd";

// const backPages = {
//   home: "/",
//   register: "/register",
//   login: "/login",
// };

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{
				path: "",
				element: <LandingPage />,
			},
			{
				path: "about",
				element: <About />,
			},
			{
				path: "service",
				element: <ServicePage />,
			},
			{
				path: "support",
				element: <SupportPage />,
			},
			{
				path: "news",
				element: <NewsPage />,
			},
			{
				path: "milestone",
				element: <Milestone />,
			},
			{
				path: "update",
				element: <Update />,
			},
			{
				path: "contact",
				element: <Contact />,
			},
		],
	},

	,
	{
		path: "/en",
		element: <LandROut />,
		errorElement: <NotFoundPage />,
		children: [
			{ path: "login", element: <LoginPage /> },
			{ path: "register", element: <RegisterPage /> },
			{
				path: "forgotpassword",
				element: <Forgotpwd />,
			},
			{
				path: "resetpassword",
				element: <ResetPasswordPage />,
			},
		],
	},

	{
		path: "/dashboard",
		element: (
			<RequiredAuth>
				<UserDashboard />
			</RequiredAuth>
		),
		errorElement: <NotFoundPage />,
		children: [
			{
				path: "",
				element: <UserDashboard />,
				children: [{ path: "", element: <UDLandingUi /> }],
			},
			// { path: "profile-settings", element: <UDSettingsUi /> },
			// { path: "market", element: <UDMktOverviewUi /> },
			// { path: "wallet", element: <UDWalletUi /> },
			// { path: "deposit", element: <UDDeposit /> },

			// { path: "txnhistory", element: <UDTxnhistoryUI /> },
		],
	},
	{
		path: "/admin",
		element: (
			<RequiredAuth>
				<AdminDashboard />
			</RequiredAuth>
		),
		children: [
			{
				path: "",
				element: <AdminDashboard />,
				children: [{ path: "", element: <ADLandingUi /> }],
			},

			{
				path: "users",
				element: <ADUsersUi />,
			},
			{
				path: "users/singleuser/:id",
				element: <ADSingleUserUi />,
			},

			{
				path: "depositUsersUi",
				element: <ADUsersWithDepositUi />,
			},
			{
				path: "withdrawalUsersUi",
				element: <ADUsersWithWithdrawaltUi />,
			},
		],
	},
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<RouterProvider router={router} />
			</AuthProvider>
		</QueryClientProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
